<template>
  <div>
    <button class="edit-image" @click="modalEdit">Edit</button>
    <ui-delete-asset-modal :asset="asset" :show="show" @close="modalEdit"></ui-delete-asset-modal>
  </div>
</template>

<script>
import UiDeleteAssetModal from "./UiDeleteAssetModal";
export default {
  components: { UiDeleteAssetModal },
  props: {
    asset: {
      required: false
    }
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    modalEdit() {
      this.show = !this.show;
    },
    deleteAsset() {
      this.$emit("deleteAsset", this.asset);
    },
    updateAsset() {
      this.$emit("updateAsset", this.asset);
    }
  }
};
</script>

<style lang="scss" scoped>
button.edit-image {
  margin: 10px 0 5px;
  padding: 2px 0;
  width: 100%;
  justify-content: center;
  background: #35373a;
  color: #ccc;
  font-size: 1.3rem;
  font-weight: 300;
  text-shadow: none;
  border-top: 1px solid #4a4d52;
}
</style>

